/* eslint-disable import/no-default-export */

import './index.scss'
import themeMixins from '@/common/mixins/theme'
import { THEME_COLOR } from '@/defines/environment/config'

export default {
  name: 'MapleNavBar',
  mixins: [themeMixins],
  props: {
    title: {
      type: String,
      default: ''
    },
    titleColor: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    subTitleColor: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    rightIcon: {
      type: String,
      default: ''
    },
    leftArrow: {
      type: Boolean,
      default: false
    },
    leftArrowColor: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: ''
    },
    safeTopDistance: {
      type: Number,
      default: 0
    },
    opacityStyle: {
      type: Boolean,
      default: false
    },
    opacity: {
      type: Number,
      default: 1
    }
  },
  methods: {
    onClickLeft(event) {
      this.$emit('click-left', event)
    },

    onClickRight(event) {
      this.$emit('click-right', event)
    },

    renderLeft(forceWhite = false) {
      const leftSlot = this.$slots.left

      if (leftSlot) {
        return leftSlot
      }

      if (forceWhite) {
        return (
          this.leftArrow && (
            <maple-icon
              class="maple-nav-bar__arrow"
              color="#444444"
              name="left_outlined"
            />
          )
        )
      } else {
        return (
          this.leftArrow && (
            <maple-icon
              class="maple-nav-bar__arrow"
              color={this.leftArrowColor}
              name="left_outlined"
            />
          )
        )
      }
    },

    renderCenter() {
      const centerSlot = this.$slots.center

      if (centerSlot) {
        return centerSlot
      }
      return [
        <div
          class={['maple-nav-bar__title', 'maple-ellipsis']}
          style={{ color: this.titleColor }}
        >
          {this.title}
        </div>,
        this.subTitle ? (
          <div
            class={['maple-nav-bar__sub-title', 'maple-ellipsis']}
            style={{ color: this.subTitleColor }}
          >
            {this.subTitle}
          </div>
        ) : (
          ''
        )
      ]
    },

    renderRight(forceWhite = false) {
      const rightSlot = this.$slots.right
      const textStyle = {
        color: THEME_COLOR
      }

      if (rightSlot) {
        return rightSlot
      }

      if (this.rightIcon) {
        if (forceWhite) {
          return (
            <maple-icon
              name={this.rightIcon}
              color="#444444"
              size={'18'}
            ></maple-icon>
          )
        } else {
          return (
            <maple-icon
              name={this.rightIcon}
              color="#262626"
              size={'18'}
            ></maple-icon>
          )
        }
      }

      if (this.rightText) {
        if (forceWhite) {
          return (
            <span class="maple-nav-bar__text" style="color: #444444;">
              {this.rightText}
            </span>
          )
        } else {
          return (
            <span class="maple-nav-bar__text" style={textStyle}>
              {this.rightText}
            </span>
          )
        }
      }
    }
  },

  render() {
    let style = {}
    if (this.background) {
      style = { background: this.background }
    } else {
      style = { background: 'white' }
    }
    if (this.safeTopDistance) {
      style = Object.assign(style, { paddingTop: this.safeTopDistance + 'px' })
    }
    if (this.opacityStyle) {
      style = Object.assign(style, {
        opacity: this.opacity
      })
      return (
        <div class="maple-nav-bar__outer-container">
          <div class="maple-nav-bar__inner-opacity-container">
            <div class="maple-nav-bar">
              <div class="maple-nav-bar__left" onClick={this.onClickLeft}>
                {this.renderLeft(true)}
              </div>
              <div class="maple-nav-bar__right" onClick={this.onClickRight}>
                {this.renderRight(true)}
              </div>
            </div>
          </div>
          <div class="maple-nav-bar__inner-solid-container" style={style}>
            <div class="maple-nav-bar">
              <div class="maple-nav-bar__left" onClick={this.onClickLeft}>
                {this.renderLeft()}
              </div>
              <div class={['maple-nav-bar__center', 'maple-ellipsis']}>
                {this.renderCenter()}
              </div>
              <div class="maple-nav-bar__right" onClick={this.onClickRight}>
                {this.renderRight()}
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div class="maple-nav-bar__container" style={style}>
          <div class="maple-nav-bar">
            <div class="maple-nav-bar__left" onClick={this.onClickLeft}>
              {this.renderLeft()}
            </div>
            <div class={['maple-nav-bar__center', 'maple-ellipsis']}>
              {this.renderCenter()}
            </div>
            <div class="maple-nav-bar__right" onClick={this.onClickRight}>
              {this.renderRight()}
            </div>
          </div>
        </div>
      )
    }
  }
}
